import React, {useEffect, useRef} from 'react';
import {Link} from "react-router-dom";

export default function TableLink({href}) {
    const linkRef = useRef(null);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    useEffect(() => {
        if (!isSafari || !linkRef.current) return;

        /** @var {HTMLAnchorElement} linkElement */
        const linkElement = linkRef.current;
        /** @var {HTMLTableRowElement} trElement */
        const trElement = linkElement.closest('tr');

        const handleClick = (event) => {
            const clickedElement = event.target;

            const checkHasRelativeElement = (startElement, endParentElement) => {
                let currentElement = startElement;
                while (currentElement && currentElement !== endParentElement) {
                    const position = window.getComputedStyle(currentElement).position;

                    if (position === 'relative') return true;

                    currentElement = currentElement.parentElement;
                }
                return false; // No element with a higher z-index found
            }

            // If an element between the clicked element and the tr element has
            // a relative position, do not trigger the link
            if (checkHasRelativeElement(clickedElement, trElement)) return;

            // If CTRL key is pressed, open link in a new tab
            if (event.ctrlKey || event.metaKey) {
                return window.open(linkElement.href, '_blank');
            }

            linkElement.click();
        };
        trElement.addEventListener('click', handleClick);

        return () => {
            trElement.removeEventListener('click', handleClick);
        }
    }, [href, isSafari]);

    return (
        <Link to={href} className={`table-link ${isSafari ? 'is-safari' : ''}`} ref={linkRef}/>
    )
}
